import api from "./apiService";

export function getBookings(page, limit, status, memberName) {
  return api
    .get(
      `/admin/bookings?page=${page}&limit=${limit}&status=${status}&name=${memberName}`
    )
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

export function getBookingDetail(id) {
  return api
    .get(`admin/bookings/${id}`)
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

export function getRejectReasons() {
  return api
    .get(`property/booking/get-reject-reasons`)
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

export async function acceptBooking(id) {
  return api
    .patch(`admin/bookings/acceptance/${id}`)
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

export async function declineBooking(id, reject_reason) {
  return api
    .patch(`admin/bookings/rejection/${id}`, reject_reason)
    .then(data => {
      return data.data;
    })
    .catch(err => {
      throw err;
    });
}

export function approveGuarantor(id) {
  return api
    .patch(`admin/bookings/guarantor-approval/${id}`)
    .then(data => {
      return data.data;
    })
    .catch(err => {
      throw err;
    });
}



//////////////////
// WEBPACK FOOTER
// ./services/booking.js
// module id = null
// module chunks = 